/* eslint-disable @typescript-eslint/no-floating-promises */
import React from 'react';
import { styled, Button as MuiButton } from '@mui/material';
import clsx from 'clsx';
import { omit } from 'lodash-es';
import { getStyle, generateClassnames, buttonClasses } from './style';
import { filterOtherNativeProps } from './util';
import { IconButton } from './IconButton';
import { HomeButton } from './HomeButton';
import useAutoLoading from './useAutoLoading';
import IconLoading from './IconLoading';
const ButtonBase = React.forwardRef((props, ref) => {
    const { children, onClick, className, style, autoFocus, startIcon, endIcon, loading, sx, classes, fullWidth, htmlType, disabled, ...restProps } = props;
    const restNativeProps = filterOtherNativeProps(restProps);
    return (React.createElement(MuiButton, { ref: ref, disableRipple: true, className: className, style: style, onClick: onClick, autoFocus: autoFocus, startIcon: startIcon, endIcon: endIcon, classes: {
            startIcon: buttonClasses.startIcon,
            endIcon: buttonClasses.endIcon,
            focusVisible: buttonClasses.focusVisible,
        }, sx: sx, fullWidth: fullWidth, type: htmlType, ...restNativeProps },
        children,
        loading ? (React.createElement("div", { "aria-hidden": true, className: buttonClasses.loadingMask },
            React.createElement(IconLoading, { className: buttonClasses.loadingIcon }))) : null));
});
const StyledButton = styled(ButtonBase)((props) => {
    const { theme } = props;
    return getStyle(theme);
});
const RefButton = React.forwardRef((props, ref) => (React.createElement(StyledButton, { ...props, ref: ref })));
const Button = React.forwardRef((props, ref) => {
    const { children, onClick, className, type, size, danger, disabled, autoFocus, startIcon, endIcon, loading, autoLoading, sx, variant, fullWidth, ...rest } = props;
    let restProps = rest;
    const [isLoading, clickCallback] = useAutoLoading({
        loading: !!loading,
        autoLoading,
        onClick,
    });
    const isBlockClick = !!(isLoading || disabled);
    if (disabled) {
        if (!('aria-disabled' in restProps)) {
            restProps['aria-disabled'] = 'true';
        }
        if (!('tabIndex' in restProps)) {
            restProps.tabIndex = -1;
        }
        restProps = omit(restProps, ['href']);
    }
    if (typeof children === 'string' && !('aria-label' in restProps)) {
        restProps['aria-label'] = children;
    }
    if (variant === 'icon') {
        return (React.createElement(IconButton, { ref: ref, className: clsx(generateClassnames({
                ...props,
                ...{
                    loading: isLoading,
                },
            }), className), size: size, type: type, disabled: disabled, autoFocus: autoFocus, sx: sx, fullWidth: fullWidth, loading: isLoading, danger: danger, onClick: isBlockClick
                ? undefined
                : clickCallback, ...restProps }, children));
    }
    if (variant === 'home') {
        return (React.createElement(HomeButton, { ref: ref, className: clsx(generateClassnames({
                ...props,
                ...{
                    loading: isLoading,
                },
            }), className), size: size, type: type, disabled: disabled, autoFocus: autoFocus, sx: sx, fullWidth: fullWidth, onClick: isBlockClick
                ? undefined
                : clickCallback, ...restProps }, children));
    }
    return (React.createElement(RefButton, { ref: ref, className: clsx(generateClassnames({
            ...props,
            ...{
                loading: isLoading,
            },
        }), className), size: size, type: type, danger: danger, disabled: disabled, autoFocus: autoFocus, startIcon: startIcon, endIcon: endIcon, loading: isLoading, sx: sx, fullWidth: fullWidth, onClick: isBlockClick
            ? undefined
            : clickCallback, ...restProps }, children));
});
export { Button, buttonClasses };
